import React, {
	SetStateAction,
	useLayoutEffect,
	useState,
	useContext
} from 'react';
import { MdModeEdit, MdDelete } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { UserMondelezProps } from 'types/UserProps';
import Load from 'components/Load';
import { color } from 'styles/pallete';
import { UseTranslationProps } from 'types/UseTranslationProps';
import ConfirmScreen from 'components/ConfirmScreen';
import { deleteUserReq } from './reqs';
import { getUsers } from 'pages/Users/reqs';
import RolesUserContext from 'context/RolesUserContext';
import {
	canAcessAdminPanel,
	getObjOnLocalStorage,
	removeSpecialCharacters,
	shrinkText
} from 'utils/functions';
import { FiltersUsersProps } from 'types/FiltersUsersProps';

interface ListUsersProps {
	setIsOpen: React.Dispatch<SetStateAction<boolean>>;
	setUserToEdit: React.Dispatch<SetStateAction<null | UserMondelezProps>>;
	listUsers: UserMondelezProps[];
	setListUsers: React.Dispatch<SetStateAction<UserMondelezProps[]>>;
	isReq: boolean;
	setQtdPages: React.Dispatch<React.SetStateAction<number>>;
	page: number;
	filters: FiltersUsersProps;
	justUsersAllowed: boolean;
}

export default function ListUsers({
	setIsOpen,
	setUserToEdit,
	listUsers,
	setListUsers,
	isReq,
	page,
	setQtdPages,
	filters,
	justUsersAllowed
}: ListUsersProps) {
	const userData: UserMondelezProps = getObjOnLocalStorage();
	const canAcess = canAcessAdminPanel(userData?.authentication?.roles || []);

	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);
	const { listRoles } = useContext(RolesUserContext);

	const { t }: UseTranslationProps = useTranslation();

	const [isConfirmDelete, setIsConfirmDelete] = useState(false);
	const [userToDelete, setUserToDelete] = useState<null | UserMondelezProps>(
		null
	);

	function filterListByRole(list: UserMondelezProps[]) {
		return list;
		//precisamos ver uma forma melhor de fazer isso, provalvelmente no backend
		// const typeActualUser = userData.authentication?.roles?.[0] || '';

		// if (typeActualUser === '') {
		// 	return [];
		// }

		// if (canAcess) {
		// 	return list;
		// }

		// const newList = list.filter(
		// 	(user) => user.authentication?.roles?.includes('sysadmin') === false
		// );

		// return newList;
	}

	function editUser(user: UserMondelezProps) {
		setUserToEdit(user);
		setIsOpen(true);
	}

	async function handleDeleteUser() {
		if (userToDelete !== null) {
			setIsOpenLoad(true);
			setMessage('Deletando usuário');

			const resp = await deleteUserReq(userToDelete?.id || '', handleNotify);

			setIsOpenLoad(false);

			if (resp) {
				const actualPageRefreshed =
					listUsers.length > 1 && page > 1 ? page : page - 1;

				setIsOpenLoad(true);
				setMessage('Atualizando lista de usuários');
				await getUsers(
					{
						filterByCpf: removeSpecialCharacters(filters.filterByCpf),
						filterByEmail: filters.filterByEmail,
						justUsersAllowed: justUsersAllowed
					},
					actualPageRefreshed,
					setListUsers,
					setQtdPages,
					handleNotify
				);

				setIsOpenLoad(false);
				setIsConfirmDelete(false);
				setUserToDelete(null);
			}
		}
	}

	function canAcessEditMode(user: UserMondelezProps) {
		if (canAcess) {
			return true;
		}

		if (!canAcess) {
			if (userData.id === user.id) {
				return true;
			} else {
				return false;
			}
		}

		return false;
	}

	//reseta o setUserToDelete toda vez q a tela de confirmação é fechada
	useLayoutEffect(() => {
		if (!isConfirmDelete) {
			setUserToDelete(null);
		}
	}, [isConfirmDelete]);

	return (
		<S.container>
			{isReq ? (
				<S.centralize>
					<Load text={t('users.listUsers.loadUsersList')} showText />
				</S.centralize>
			) : (
				<>
					<S.header>
						<p>{t('Nome')}</p>
						<p>E-mail</p>
						<p>Tipo</p>
						<p>{t('users.listUsers.actions')}</p>
					</S.header>

					<S.line />

					{!isReq && listUsers.length === 0 ? (
						<S.centralize>
							<S.noUsers>{t('users.listUsers.noUsers')}</S.noUsers>
						</S.centralize>
					) : (
						<S.list>
							{filterListByRole(listUsers).map((user, i) => (
								<React.Fragment key={user?.id || i}>
									<S.itemList>
										<p>
											{user?.fullName || t('users.listUsers.nameNotRegisterd')}
										</p>

										<p>
											{shrinkText(user?.email, 25) ||
												t('users.listUsers.emailNotRegistered')}
										</p>

										<p>
											{user?.authentication?.roles &&
											user?.authentication?.roles.length > 0
												? user?.authentication?.roles[0]
												: 'Sem tipo'}
										</p>

										<S.actions>
											{listRoles.length > 0 && (
												<MdModeEdit
													cursor={
														canAcessEditMode(user) ? 'pointer' : 'not-allowed'
													}
													size={25}
													color={color.interface.darkgray}
													onClick={() => {
														if (canAcessEditMode(user)) {
															editUser(user);
														}
													}}
												/>
											)}

											<MdDelete
												cursor={canAcess ? 'pointer' : 'not-allowed'}
												size={25}
												color={color.interface.darkgray}
												onClick={() => {
													if (canAcess) {
														setUserToDelete(user);
														setIsConfirmDelete(true);
													}
												}}
											/>
										</S.actions>
									</S.itemList>

									<S.line />
								</React.Fragment>
							))}
						</S.list>
					)}
				</>
			)}

			<ConfirmScreen
				setIsOpen={setIsConfirmDelete}
				isOpen={isConfirmDelete}
				title="dynamicShowCase.listDynamicShowCase.confirmation"
				message={
					<p>
						{t('users.listUsers.deleteMessager')}{' '}
						<b style={{ fontFamily: 'nunito-bold' }}>
							{userToDelete?.firstName || t('users.listUsers.nameNotRegisterd')}
						</b>
						?
					</p>
				}
				buttonClose={false}
				functionToExecOnConfirm={handleDeleteUser}
			/>
		</S.container>
	);
}
